// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';

export default styled<any, Theme>('div')`
  padding-top: 1.875rem;
  min-height: 5.5rem;
`;
